<template>
 <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data(){
    return {

    }
  },
  mounted: function () {

  }
}
</script>


<style>

@import "../node_modules/@syncfusion/ej2-base/styles/fluent.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/fluent.css";
@import "../node_modules/@syncfusion/ej2-calendars/styles/fluent.css";
@import "../node_modules/@syncfusion/ej2-dropdowns/styles/fluent.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/fluent.css";
@import '../node_modules/@syncfusion/ej2-lists/styles/fluent.css';
@import '../node_modules/@syncfusion/ej2-layouts/styles/fluent.css';
@import '../node_modules/@syncfusion/ej2-navigations/styles/fluent.css';
@import '../node_modules/@syncfusion/ej2-popups/styles/fluent.css';
@import '../node_modules/@syncfusion/ej2-splitbuttons/styles/fluent.css';
@import '../node_modules/@syncfusion/ej2-grids/styles/fluent.css';
@import '../node_modules/@syncfusion/ej2-treegrid/styles/fluent.css';
@import '../node_modules/@syncfusion/ej2-gantt/styles/fluent.css';
@import '../node_modules/@syncfusion/ej2-vue-gantt/styles/fluent.css';
@import '../node_modules/@syncfusion/ej2-vue-schedule/styles/fluent.css';
@import "../node_modules/@syncfusion/ej2-vue-grids/styles/fluent.css";
@import "../node_modules/@syncfusion/ej2-vue-kanban/styles/fluent.css";
@import "../node_modules/@syncfusion/ej2-vue-navigations/styles/fluent.css";






</style>
